module.exports = __webpack_public_path__ + "static/media/7.698eb5fc.png";